export const COLORS = {
  primary: "#277B33",
  secondary: "#003764",
  textDark: "#49454F",
  textLight: "#FFFFFF",
  disabledCalendarText: "#F2F2F2",
  backgroundColor: "#f7f7f7",
  border: "#757575",
  textDarker: "#191825",
  backgroundGreen: "#E8F5E9",
  warning: "#d76100",
  warningLight: "#FFF3E0",
  warningText: "#B04F00",
  error: "#D32F2F",
  errorLight: "#FFEBEE",
  blueBackground: "#DDEBF3",
  blueBorder: "#77819D",
  backgroundColorDark: "#EEEEEE",
  vbgoBlue: "#133455",
  parkingYellow: "#B38B00",
  parkingRed: "#B22222",
  parkingGreen: "#006400",
  parkingGray: "#6D6D6D",
};
